var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"30px"}},[(_vm.error)?[_vm._v("\n    "+_vm._s(_vm.$t("auth.logout.error"))+"\n  ")]:[_vm._v("\n    "+_vm._s(_vm.$t("auth.logout.title"))+"\n  ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }